import { NotificationsTranslations } from '../en-US/notifications.translations';

export const notificationsTranslations: NotificationsTranslations = {
  title: 'Notifications',
  pageTitle: 'Notifications',
  pageDescription: 'Voir et gérer vos notifications',
  settingsTitle: 'Paramètres des notifications',
  settingsPageTitle: 'Paramètres des notifications',
  settingsPageDescription: 'Gérer vos préférences de notifications',
  settings: 'Paramètres',
  markAsRead: 'Marquer comme lu',
  markAllAsRead: 'Tout marquer comme lu',
  delete: 'Supprimer',
  more: 'plus',
  noNotifications: 'Aucune notification',
  emptyDescription: "Vous n'avez pas encore de notifications",
  errorLoading: 'Erreur lors du chargement des notifications',
  errorLoadingSettings: 'Erreur lors du chargement des paramètres de notification',
  tryAgain: 'Veuillez réessayer plus tard',
  enableNotifications: 'Activer les notifications',
  enablePromptMessage: 'Restez informé des derniers avis, likes et abonnés en activant les notifications.',
  remindLater: 'Me le rappeler plus tard',
  enable: 'Activer',
  stayUpdated: 'Restez informé',
  enableDescription: 'Activez les notifications pour rester informé des nouveaux avis, likes et abonnés.',
  pushNotifications: 'Notifications push',
  pushDescription: 'Recevez des notifications sur votre appareil',
  emailNotifications: 'Notifications par e-mail',
  emailDescription: 'Recevez des notifications par e-mail',
  enableAllNotifications: 'Activer toutes les notifications',
  masterToggleDescription: 'Activer/désactiver toutes les notifications',
  notificationTypes: 'Types de notifications',
  types: {
    reviewLiked: 'Avis aimé',
    reviewLikedDescription: "Recevez une notification lorsque quelqu'un aime votre avis",
    newPlaceReviews: 'Nouveaux avis de lieux',
    newPlaceReviewsDescription: "Recevez une notification lorsqu'un nouveau lieu est évalué",
    newFoodReviews: 'Nouveaux avis de nourriture',
    newFoodReviewsDescription: "Recevez une notification lorsqu'un nouveau plat est évalué",
    newReviewCreated: 'Nouvel avis créé',
    newReviewCreatedDescription: "Recevez une notification lorsqu'un nouvel avis est créé",
    userFollowed: 'Utilisateur suivi',
    userFollowedDescription: "Recevez une notification lorsqu'un utilisateur vous suit",
  },
}; 

export default notificationsTranslations;
